export const corto = (n) => {
  const v = Math.abs(Number(n) || 0);
  if (v >= 1e6) return `${(v / 1e6).toLocaleString("es-PY", { maximumFractionDigits: 2 })}M`;
  if (v >= 1e3) return `${Math.round(v / 1e3)}K`;
  return `${Math.round(v)}`;
};
export const pct = (a, b, dec = 1) => (b ? Math.round((a / b) * 100 * 10 ** dec) / 10 ** dec : 0);
export const pctTxt = (a, b) => { const r = b ? (a / b) * 100 : 0; return r > 0 && r < 0.1 ? "<0,1%" : `${(Math.round(r * 10) / 10).toLocaleString("es-PY", { maximumFractionDigits: 1 })}%`; };
export const TRAMOS = [
  { id: "vencido", n: "Vencido", c: "#E07A62", t: (d) => d > 0 },
  { id: "p30", n: "Próximos 30 días", c: "#D2A23A", t: (d) => d <= 0 && -d <= 30 },
  { id: "p180", n: "31–180 días", c: "#7DBEE6", t: (d) => -d > 30 && -d <= 180 },
  { id: "p365", n: "181–365 días", c: "#5FA8D9", t: (d) => -d > 180 && -d <= 365 },
  { id: "mas", n: "Más de 1 año", c: "#2E9A5E", t: (d) => -d > 365 },
];
export const composicion = (venc) => {
  const m = Object.fromEntries(TRAMOS.map((t) => [t.id, 0]));
  (venc || []).forEach((v) => {
    if (v.dias === null || v.dias === undefined) { m[v.estado === "vencido" ? "vencido" : "p180"] += v.monto; return; }
    const t = TRAMOS.find((x) => x.t(v.dias)); m[t ? t.id : "mas"] += v.monto;
  });
  return TRAMOS.map((t) => ({ ...t, monto: m[t.id] }));
};
export const colorEstado = (dias) => (dias > 0 ? "#E07A62" : -dias <= 30 ? "#D2A23A" : "#2E9A5E");
export const diasTxt = (dias) => (dias > 0 ? `Vencido hace ${dias} día${dias === 1 ? "" : "s"}` : dias === 0 ? "Vence hoy" : `Vence en ${-dias} día${dias === -1 ? "" : "s"}`);
export const sumaD = (iso, n) => { const d = new Date(`${iso}T00:00:00`); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
export const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "set", "oct", "nov", "dic"];
